



























































































//本页面为问政榜单
import { Component, Vue } from "vue-property-decorator";
import { dateFormat } from "@/common/Utils";
import {
  Picker as vanPicker,
  Popup as vanPopup,
  Image as vanImage
} from "vant";
import request from "@/api/index";
import {
  IWenzhengScoreResponse,
  IWenzhengScore,
  IResponse,
  ICircleScoreboard,
  IScoreboardResponse,
  IDateList
} from "@/api/types";

@Component({
  components: {
    vanPicker,
    vanPopup,
    vanImage
  }
})
export default class App extends Vue {
  isShowRules = false;

  isShowDateSelect = false;
  columns: IDateList[] = [];
  chooseItem: IDateList = {} as IDateList;
  defaultIndex = 0;

  listParams: any = {
    appId: "",
    beginTime: "2021-10-1",
    endTime: "2021-12-1",
    circleTypeId: ""
  };
  list: ICircleScoreboard[] = [];
  navTypeData: any[] = [
    {
      id: 1,
      text: "月榜"
    },
    {
      id: 2,
      text: "季榜"
    },
    {
      id: 3,
      text: "年榜"
    }
  ];
  currentNav: number = 0;
  quanziDetail: any = {};
  mounted() {
    this.listParams.appId = (this.$route.query.appId as string) || "28";
    this.listParams.circleTypeId = (this.$route.query.id as string) || "1";
    document.title = "圈子榜单";

    // this.listParams.beginTime = this.chooseItem.startTime;
    // this.listParams.endTime = this.chooseItem.endTime;

    this.getDateList().then(() => {
      this.chooseItem = this.columns[0]; // 默认
      this.listParams.beginTime = this.chooseItem.beginTime;
      this.listParams.endTime = this.chooseItem.endTime;
      this.getList();
    });
    this.getDetail();

    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "圈子榜单",
        isShowMoreBtn: "1"
      });
      ZWY_CLOUD.shareConfig({
        id: "",
        shareTitle: "看万州圈子榜单",
        shareDescription: "",
        sourceType: "1",
        shareImgUrl: "https://imagecdn.cqliving.com/images/icon/28.png",
        shareUrl: window.location.href,
        shareUrlQQ: window.location.href,
        shareUrlQzone: window.location.href,
        shareUrlWx: window.location.href,
        shareUrlWxMoments: window.location.href,
        shareUrlWeibo: window.location.href
      });
    }
  }

  chooseNav(index: number) {
    this.currentNav = index;
    this.getDateList().then(() => {
      this.chooseItem = this.columns[0]; // 默认
      this.listParams.beginTime = this.chooseItem.beginTime;
      this.listParams.endTime = this.chooseItem.endTime;
      this.getList();
    });
  }

  getDateList() {
    return request
      .getScoreboardDateList({
        type: this.navTypeData[this.currentNav].id
      })
      .then((res: IScoreboardResponse<IDateList>) => {
        if (res.code >= 0) {
          this.columns = res.data;
        }
      });
  }

  toCheckRule() {
    this.isShowRules = true;
  }
  toSlectDate() {
    this.isShowDateSelect = true;
  }
  onConfirm(data: IDateList) {
    this.chooseItem = data;
    this.isShowDateSelect = false;

    this.listParams.beginTime = this.chooseItem.beginTime;
    this.listParams.endTime = this.chooseItem.endTime;
    this.getList();
  }

  getList() {
    // this.listParams.circleTypeId = this.navTypeData[this.currentNav].id;
    request
      .circleScoreboard(this.listParams)
      .then((res: IScoreboardResponse<ICircleScoreboard>) => {
        if (res.code >= 0) {
          this.list = res.data;
        }
      });
  }
  getDetail() {
    request
      .quanziDetail({
        appId: this.listParams.appId,
        circleTypeId: this.listParams.circleTypeId
      })
      .then((res: any) => {
        if (res.code >= 0) {
          this.quanziDetail = res.data;
        }
      });
  }

  toDetail() {
    this.$router.push({
      path: "/wenzhengRankingDetail",
      query: {
        beginTime: this.listParams.beginTime,
        endTime: this.listParams.endTime,
        appId: this.listParams.appId
      }
    });
  }
}
